

import {clsx} from 'external/clsx'
import {ChangeEventHandler, FC, Form, FormCheckType} from 'external/react'

type ConfigurationCheckboxProps = {
  label: string
  type: FormCheckType
  name: string
  value: string
  checked?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
}

const ConfigurationCheckbox: FC<ConfigurationCheckboxProps> = props => {
  const {type, name, checked, onChange, label} = props
  return (
    <span className={clsx('configuration-checkbox', name)}>
      <Form.Check type={type} id={name} value={name} checked={checked} onChange={onChange}>
      </Form.Check>
      <Form.Label className='mx-3' htmlFor={name}>{label}</Form.Label>
    </span>)
}

export {ConfigurationCheckbox as default}